export {modalOptions, UserProfileComponent as UserProfile} from './UserProfileComponent';



// WEBPACK FOOTER //
// ./src/js/user-profile/compoments/UserProfile/index.js